import { Rule } from 'entities/campaign';
import { State } from 'store';
import { Selectors as GenericSelectors } from './genericService';

export const nextRulesetId = (currentIds: string[]): string => {
  const matchingNumbers = currentIds
    .map(id => /^ruleset-(\d+)$/g.exec(id))
    .filter(match => match)
    .map(match => Number(match[1]));
  const nextId = matchingNumbers.length === 0 ? 0 : Math.max(...matchingNumbers) + 1;
  return `ruleset-${nextId}`;
};

const newRulesetId = (state: State): string => {
  const ids = GenericSelectors.getUpdatedEntityIds(state) || [];
  return nextRulesetId(ids);
};

export const Selectors = {
  ...GenericSelectors,
  getRule: (state: State, rulesetId: string, ruleIndex: number): Rule => {
    const ruleset = GenericSelectors.getUpdatedEntity(state, rulesetId);
    if (!ruleset || !ruleset.rules || ruleset.rules.length < ruleIndex) {
      return undefined;
    }
    return ruleset.rules[ruleIndex];
  },
  newRulesetId,
};
